export const FlagsForm = () => {
  return <>form</>
}
